import { Component } from '@verndale/core';
import Swiper, { Navigation, Pagination } from 'swiper';
import { BREAKPOINTS } from '../utils';
import ReadMore from './article-read-more';

Swiper.use([Navigation, Pagination]);

class Module extends Component {
  setupDefaults() {
    this.dom = {
      $listing: this.el.querySelectorAll('.card'),
      $readMoreBtn: this.el.querySelector('.article-listing__cta'),
      $swiperContainer: this.el.querySelector('.swiper'),
      $swiperSlides: this.el.querySelectorAll('.swiper-slide'),
      $swiperPagination: this.el.querySelector('.swiper-pagination'),
      $swiperNextButton: this.el.querySelector('.swiper-button-next'),
      $swiperPrevButton: this.el.querySelector('.swiper-button-prev'),
      $swiperPaginationContainer: this.el.querySelector(
        '.article-listing__pagination'
      )
    };

    this.isSmall = this.el.closest('.dual-column-container__main');

    this.maxArticles = parseInt(this.el.dataset.maxArticles, 10);
    this.initialArticles = parseInt(this.el.dataset.initialArticles, 10);
    this.hasVideo = this.el.classList.contains('article-listing--video');

    if (this.hasVideo) {
      this.readMore = new ReadMore({
        items: this.dom.$listing,
        readMoreBtn: this.dom.$readMoreBtn,
        maxArticles: this.maxArticles,
        element: this.el,
        itemsFirstTime: this.initialArticles
      });
    }

    if (this.dom.$swiperSlides.length < 2)
      this.dom.$swiperPaginationContainer?.classList.add(
        'article-listing__pagination--disabled'
      );

    this.initSwiper();
  }

  addListeners() {
    if (this.hasVideo) {
      this.dom.$readMoreBtn.addEventListener('click', () =>
        this.readMore.handleReadMore()
      );
    }
  }

  initSwiper() {
    const { length } = this.dom.$swiperSlides;

    let slidesPerView = 0;

    if (this.isSmall) {
      slidesPerView = length >= 2 ? 2 : length;
    } else {
      slidesPerView = length >= 4 ? 4 : length;
    }

    this.swiper = new Swiper(this.dom.$swiperContainer, {
      a11y: true,
      rewind: true,
      direction: 'horizontal',
      slidesPerView: 1,
      spaceBetween: 32,
      watchOverflow: true,
      enabled: length > 1,
      roundLengths: false,
      breakpoints: {
        [BREAKPOINTS.TABLET]: {
          enabled: false,
          slidesPerView: length > 1 ? 2 : length,
          spaceBetween: 0
        },
        [BREAKPOINTS.TABLET_LANDSCAPE]: {
          enabled: false,
          slidesPerView,
          spaceBetween: 0
        }
      },
      pagination: {
        el: this.dom.$swiperPagination,
        type: 'fraction'
      },
      navigation: {
        nextEl: this.dom.$swiperNextButton,
        prevEl: this.dom.$swiperPrevButton
      },
      watchSlidesProgress: true
    });
  }
}

export default Module;
